'use strict';

angular.module('internal.applications')
    .directive('internalApplicationNavigation', [function () {
        return {
            restrict: 'E',
            templateUrl: paths.app + 'applications/components/application-navigation/application-navigation.html',
            replace: true,
            controller: ('InternalNavigation', ['$scope', 'Enterprise', function ($scope, Enterprise) {
                $scope.educationModuleOn = false;

                Enterprise.get().then(function (enterprise) {
                    if (enterprise != null) {
                        $scope.educationModuleOn = (enterprise.education_module == null ? false : enterprise.education_module);
                    }
                })
            }])
        };
    }])
;